"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToFullyVisible = void 0;
var _scrollToFullyVisibleX = require("./scrollToFullyVisibleX");
var _scrollToFullyVisibleY = require("./scrollToFullyVisibleY");
var scrollToFullyVisible = exports.scrollToFullyVisible = function scrollToFullyVisible(_ref) {
  var container = _ref.container,
    element = _ref.element;
  (0, _scrollToFullyVisibleY.scrollToFullyVisibleY)({
    container: container,
    element: element
  });
  (0, _scrollToFullyVisibleX.scrollToFullyVisibleX)({
    container: container,
    element: element
  });
};